<template>
  <div>
    <!-- dialog -->
    <v-dialog
      v-model="dialog"
      max-width="500px"
      @click:outside="close"
      @keydown.esc="close"
    >
      <v-card>
        <v-progress-linear
          :active="isDialogVisible"
          :indeterminate="isDialogVisible"
          absolute
          top
          color="primary"
        ></v-progress-linear>
        <v-card-title>
          <span class="headline">Modifier {{ api.name }}</span>
        </v-card-title>
        <v-alert
          v-model="isAlertVisible"
          color="error"
          text
          transition="slide-y-transition"
        >
          {{ message }}
        </v-alert>
        <v-form
          ref="form"
          @submit.prevent="submitForm"
        >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-text-field
                    v-model="api.name"
                    type="text"
                    label="Libellé"
                    :rules="rules.name"
                  ></v-text-field>
                  <v-text-field
                    v-model="api.min_amount"
                    type="text"
                    label="Montant minimal (FCFA)"
                    :rules="rules.min_amount"
                  ></v-text-field>
                  <v-text-field
                    v-model="api.max_amount"
                    type="text"
                    label="Montant maximal (FCFA)"
                    :rules="rules.max_amount"
                  ></v-text-field>
                  <v-select
                    v-model="api.is_sandbox"
                    :items="answers"
                    label="SANDBOX?"
                    clearable
                    persistent-hint
                    :rules="rules.is_sandbox"
                  ></v-select>
                  <v-select
                    v-model="api.is_active"
                    :items="answers"
                    label="ACTIF?"
                    clearable
                    hide-details="auto"
                    persistent-hint
                    :rules="rules.is_active"
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              outlined
              @click="close"
            >
              Annuler
            </v-btn>
            <v-btn
              :disabled="isDialogVisible"
              :loading="isDialogVisible"
              color="success"
              type="submit"
            >
              Modifier
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getCurrentInstance, ref } from '@vue/composition-api'
import { mdiCalendar, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import { mapState } from 'vuex'
import store from '@/store'

export default {
  name: 'ApiFormDialog',

  emits: ['clickout', 'submitted'],

  props: {
    // eslint-disable-next-line vue/require-default-prop,vue/require-prop-type-constructor
    dialog: {
      type: Boolean,
      default: false,
    },
    // eslint-disable-next-line vue/require-default-prop
    api: {
      id: null,
      name: null,
      code: null,
      min_amount: null,
      max_amount: null,
      callback: null,
      is_sandbox: null,
      is_active: null,
    },
  },

  computed: {
    ...mapState('upload', ['file']),
  },

  watch: {
    dialog(val) {
      // eslint-disable-next-line no-unused-expressions
      val || this.close()
    },
  },

  methods: {
    close() {
      this.$emit('clickout')
    },
  },

  setup(props) {
    const isPasswordVisible = ref(false)
    const isPasswordConfirmationVisible = ref(false)
    const date = ref(null)
    const menu = ref(false)
    const picker = ref(null)
    const menuref = ref(null)
    const form = ref(null)
    const message = ref('')
    const isDialogVisible = ref(false)
    const errors = ref('')
    const isAlertVisible = ref(false)
    const rules = {
      name: [true],
      min_amount: [true],
      max_amount: [true],
      is_active: [true],
      is_sandbox: [true],
    }
    const instance = getCurrentInstance()

    const close = () => {
      isAlertVisible.value = false
      message.value = ''
      Object.keys(rules).forEach(key => {
        rules[key] = true
      })
      instance.emit('clickout')
    }

    const submitForm = () => {
      isAlertVisible.value = false
      isDialogVisible.value = true
      instance.emit('submitted')
      store.dispatch('api/updateApi', props.api).then(() => {
        isDialogVisible.value = false
        close()
      }).catch(error => {
        form.value.validate()
        message.value = error.response.data.message
        errors.value = error.response.data.errors
        if (error.response.data.errors !== undefined) {
          rules.name = error.response.data.errors.name !== undefined ? error.response.data.errors.name[0] : true
          rules.is_sandbox = error.response.data.errors.is_sandbox !== undefined ? error.response.data.errors.is_sandbox[0] : true
          rules.is_active = error.response.data.errors.is_active !== undefined ? error.response.data.errors.is_active[0] : true
          rules.max_amount = error.response.data.errors.max_amount !== undefined ? error.response.data.errors.max_amount[0] : true
          rules.min_amount = error.response.data.errors.min_amount !== undefined ? error.response.data.errors.min_amount[0] : true
        }
        isDialogVisible.value = false
        isAlertVisible.value = true
      })
      instance.emit('submitted')
    }

    return {
      close,
      isPasswordVisible,
      isPasswordConfirmationVisible,
      isAlertVisible,
      isDialogVisible,
      message,
      rules,
      submitForm,
      form,
      date,
      menu,
      picker,
      menuref,
      answers: [
        { text: 'OUI', value: true },
        { text: 'NON', value: false },
      ],

      // icons
      icons: {
        mdiCalendar, mdiEyeOutline, mdiEyeOffOutline,
      },
    }
  },
}
</script>

<style scoped>

</style>
